import { render } from "./ImportSessionAgenda.vue?vue&type=template&id=0c844860&scoped=true"
import script from "./ImportSessionAgenda.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ImportSessionAgenda.vue?vue&type=script&charset=utf-8&lang=js"

import "./ImportSessionAgenda.vue?vue&type=style&index=0&id=0c844860&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c844860"]])

export default __exports__